// Jobs-tab filters and Dataset case/slide job filters are different URL params.
// Procedures requests only accept the backend jobsFilters field, so map the Dataset
// param at this boundary and drop the Jobs-tab param. Never reuse one URL key for both.

export const JOBS_TAB_FILTERS_PARAM = 'jobsFilters';
export const JOBS_TAB_FILTERS_INCLUDE_EXCLUDE_PARAM = 'jobsFiltersIncludeExclude';
export const DATASET_JOB_FILTERS_PARAM = 'datasetJobFilters';
export const DATASET_JOB_FILTERS_INCLUDE_EXCLUDE_PARAM = 'datasetJobFiltersIncludeExclude';

export const toProceduresQueryString = (queryParams: string): string => {
  const searchParams = new URLSearchParams(queryParams);
  const datasetJobFilters = searchParams.get(DATASET_JOB_FILTERS_PARAM);
  const datasetJobFiltersIncludeExclude = searchParams.get(DATASET_JOB_FILTERS_INCLUDE_EXCLUDE_PARAM);

  searchParams.delete(JOBS_TAB_FILTERS_PARAM);
  searchParams.delete(JOBS_TAB_FILTERS_INCLUDE_EXCLUDE_PARAM);
  searchParams.delete(DATASET_JOB_FILTERS_PARAM);
  searchParams.delete(DATASET_JOB_FILTERS_INCLUDE_EXCLUDE_PARAM);

  if (datasetJobFilters) {
    searchParams.set(JOBS_TAB_FILTERS_PARAM, datasetJobFilters);
  }
  if (datasetJobFiltersIncludeExclude) {
    searchParams.set(JOBS_TAB_FILTERS_INCLUDE_EXCLUDE_PARAM, datasetJobFiltersIncludeExclude);
  }

  return searchParams.toString();
};
